/**
 * @generated SignedSource<<3881ebc2511502edd2b1482e24888505>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TitleColumn_TreeStateFragment$data = {
  readonly rootNode: {
    readonly structureDefinition: {
      readonly title?: string;
    };
  };
  readonly " $fragmentType": "TitleColumn_TreeStateFragment";
};
export type TitleColumn_TreeStateFragment$key = {
  readonly " $data"?: TitleColumn_TreeStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TitleColumn_TreeStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleColumn_TreeStateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeNode",
      "kind": "LinkedField",
      "name": "rootNode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "structureDefinition",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "type": "RootStructureDefinition",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeState",
  "abstractKey": null
};

(node as any).hash = "1d1a73bc19daafdcf70fbbef32dffd2d";

export default node;
